import ManagementBlock from "../common/blocks/ManagementBlock";
const Management = () => {
	return (
	<>		
		<ManagementBlock />		
	</>
	);
};
export default Management;